export default {
  'page.common.trader':'交易員',
  'page.common.startChallenge':'開始挑戰',
  'page.common.freeChallenge':'免費挑戰',
  // footer
  'pages.footer.text1':'加入我們',
  'pages.footer.text2':'我們在全球擁有超過百萬社區用戶，加入我們一起交流吧',
  'pages.footer.text3':'關於我們',
  'pages.footer.text4':'公告中心',
  'pages.footer.text5':'Cookie政策',
  'pages.footer.text6':'隱私說明',
  'pages.footer.text7':'反洗錢政策',
  'pages.footer.text8':'服務條款',
  'pages.footer.text9':'社區',
  'pages.footer.text10':'Telegram社區',
  'pages.footer.text11':'Discord社區',
  'pages.footer.text12':'Findtrader公司並非經紀商，不接受任何存款。本網站僅向交易者提供模擬交易和金融市場交易相關的教育服務，不構成任何具體的投資建議。及其包含的所有信息、材料和服務（統稱爲“內容”）並非專門針對任何特定國家或司法管轄區的居民而設計或提供。',
  'pages.footer.text13':'公司名稱',
  'pages.footer.text14':'公司地址：香港 荃灣 柴灣角街66-82 金熊工業中心 19樓AD座40B房',
  'pages.footer.text15':'註冊號',
  'pages.footer.text16':'郵箱',
  // 首頁
  'pages.home.banner.text1':'成為',
  'pages.home.banner.text2':'從這裡開始！',
  'pages.home.banner.text3':'通過模擬挑戰，贏取資助賬戶基金',
  'pages.home.banner.text4':'交易賬戶',
  'pages.home.banner.text5':'累計用戶',
  'pages.home.banner.text6':'考核時間',
  'pages.home.banner.text7':'提供資金',
  'pages.home.company.title1':'選擇',
  'pages.home.company.title3':'的理由',
  'pages.home.company.title4':'仿真環境',
  'pages.home.company.title5':'實戰',
  'pages.home.company.title6':'演練技巧',
  'pages.home.company.text1':'平臺高度還原了數字貨幣市場的真實交易場景，包括價格波動、交易規則、市場氛圍等各個方面，為交易者提供了一個無風險、高度仿真的實戰演練平臺。在這裏，您可以自由探索交易策略，不斷磨練交易技巧，提升決策效率、為未來的真實交易奠定堅實基礎。',
  'pages.home.challenge.title1':'挑戰',
  'pages.home.challenge.title2':'流程',
  'pages.home.challenge.firstStep':'第一步',
  'pages.home.challenge.twoStep':'第二步',
  'pages.home.challenge.threeStep':'第三步',
  'pages.home.challenge.text1':'請前往官官網註冊並登錄',
  'pages.home.challenge.text2':'根據您的經驗和需求選擇最合適您的挑戰方案',
  'pages.home.challenge.text3':'另外，每月可以免費參與全球模擬交易',
  'pages.home.challenge.text4':'不同方案設有1-2個的獲利目標，完成每項挑戰後聯絡相應工作人員以獲得獎勵。',
  'pages.home.challenge.text5':'兌換獎勵後繼續進入下一階段比賽。',
  'pages.home.challenge.text6':'通關後簽署協議，成為findtrader資助的交易者!',
  'pages.home.challenge.text7':'參與者無需承擔交易風險或支付費用，即可獲得6:4利潤分紅，利潤超過10%可以申請雙倍資金。',
  'pages.home.challenge.btn1':'獲取獎勵',
  'pages.home.challenge.btn2':'利潤分紅',
  'pages.home.product.title1':'交易目標',
  'pages.home.product.title2':'選擇令你最成功的方案',
  'pages.home.product.button1':'基礎版',
  'pages.home.product.button2':'進階版',
  'pages.home.account.title':'賬號使用流程',
  'pages.home.account.firstStep.title':'官網註冊',
  'pages.home.account.firstStep.text':'您可以掃描邀請碼或者輸入我們的官網地址(www.fndtrader.net)，進入官網。',
  'pages.home.account.twoStep.title':'領取賬戶',
  'pages.home.account.twoStep.text':'進入個人中心，點擊「我的賬戶」--立即申請賬戶，它網將含跳轉至方案頁面供你選擇領取。',
  'pages.home.account.threeStep.title':'選擇方案',
  'pages.home.account.threeStep.text':'初次登多用戶，可送揮免費參賽方案、點擊立即參與，即可獲得免費賬戶。',
  'pages.home.account.fourStep.title':'下載並登錄賬戶',
  'pages.home.account.fourStep.text':'在官網操碼下載app，輸入您郵箱中獲得的賬號及密碼進行登錄。登陸後建議您及時修改您的賬號密碼!我們的app端僅用於登錄和操作您已獲取的賬戶。',
  'pages.home.userInfo.title':'受到世界各地交易者的',
  'pages.home.userInfo.titleColor':'信賴',
  'pages.home.userInfo.subTitle':'了解為什麼全球如此多的交易員選擇Findtrader作為他們首選的PROP FIRM',
  'pages.home.community.title1':'加入我們的',
  'pages.home.community.title2':'精英',
  'pages.home.community.title3':'交易社區',
  'pages.home.community.subTitle':'受益於以一個志同道合的個人組成的社區，大家通過交易獲得成功。',

  // 關於
  'pages.about.banner.title':'全球首家模擬交易選拔平臺',
  'pages.about.banner.text':'我們是findtrader，專業投資六年，幣圈首家與頂尖交易所深度合作的專業機構，自成立以來，我們已投入高達8000萬美金用於扶持交易員實現自我價值。我致力於孵化並培養頂尖的交易員，為數字貨幣市場註入新的活力與智慧。',
  'pages.about.brandStory':'Findtrader的誕生，是基於對數字貨幣市場複雜性與不定性的深刻理解。\n在市場中，交易員的專業能力與經驗是決定其能否脫穎而出、贏得投資者青睞的關鍵。然而，市場的多變性與風險性往往讓交易員難以在短時間內積累足夠的實戰經驗。Findtrader應運而生，旨在通過創建一個科學嚴謹的數字貨幣市模擬交易比賽平臺，為交易員提供一個低風險、高效率的實戰演練，我們的平臺，融合了金融科技的前沿成果與金融市場的實際需求。通過一系列科學嚴謹的評估標準和規則，我們能夠全面、客觀地分析交易者的能力與表現，投資者提供更高質量的數據觀察架構。這不僅有助於投資者深入洞察交易員的綜合情況，做出更加明智的投資決策，也為交易員提供了一個展示自我、提升自我的寶貴機會。\nFindtrader不僅是一個比賽平臺，更是一個金融科技的創新航標。我們致力於推動數字貨幣市場的健康發展，通過持續的技術創新和服務優化，為投資者與交易員創造更多價值。我們的團隊由來自金融、數據分析、軟件等領域的精英組成，他們憑藉豐富的經驗和敏銳的洞察力，為Findtrader的健康發展提供了堅實保障。',
  'pages.about.mission':'我們的使命我們的使命我們的使命',
  'pages.about.btn1':'品牌故事',
  'pages.about.btn2':'我們的使命',
  'pages.about.milestone':'里程碑',
  'pages.about.values':'價值觀',
  'pages.about.Advantage.title1':'優勢',
  'pages.about.Advantage.title2':'的',

  // 產品-挑戰規則
  'pages.rule.productIntroduction.title':'比賽介紹',
  'pages.rule.productIntroduction.text':'Findtrader是一款模擬加密貨幣交易的策略比賽。\n交易員將扮演一名虛擬貨幣投資者，在與真實市場的同步的交易虛擬幣市場中進行投資、交易和管理自己的資產組合。通過智慧和策略，交易員可以積累財富，成為虛擬幣中的傑出交易員。通過模擬考核的交易員，會獲得我們提供的頂級交易所的真實賬戶，並獲得真實獎金。\n每月，參與者將有一次免費參與比賽的機會，體驗交易的刺激。若在免費模式中未能取得成功，參與者可參考官方網站提供的價格表，選擇合適的付費套餐繼續參與比賽。',
  'pages.rule.operation.title':'交易操作',
  'pages.rule.operation.text':'1.本金虧損5%或者賬戶最大動態回撤6%時，強平所有倉位，選手則被淘汰;\n' +
      '2.單日結算盈利大於初始本金 2%的，按 2%計算後，有效盈利達到對應賬戶規定的盈利目標，即為通過比賽:\n' +
      '3.比賽支持現貨、合約交易品種，不限制現貨及合約倍數;不限制隔夜，不限制倉位;',
  'pages.rule.operation.firstStep':'資產管理',
  'pages.rule.operation.firstStep.text':'交易員可以查看自己的資產組合，包括持有的虛擬幣種類和數量。\n' +
      '交易員可以設置止損和止盈點，系統將自動執行賣出操作以保護利潤或減少損失。',
  'pages.rule.operation.twoStep':'資產管理',
  'pages.rule.operation.twoStep.text':'交易員可以查看自己的資產組合，包括持有的虛擬幣種類和數量。\n' +
      '交易員可以設置止損和止盈點，系統將自動執行賣出操作以保護利潤或減少損失。',
  'pages.rule.operation.threeStep':'說明',
  'pages.rule.operation.threeStep.text':'交易員可以查看自己的資產組合，包括持有的虛擬幣種類和數量。\n' +
      '交易員可以設置止損和止盈點，系統將自動執行賣出操作以保護利潤或減少損失。',
  'pages.rule.precautions.title1':'賬戶',
  'pages.rule.precautions.title2':'注意事項',
  'pages.rule.precautions.title3':'說明',
  'pages.rule.precautions.text':'由於通訊系統繁忙、中斷、電力中斷、計算機、網絡、風控等各種系統故障所導致的交易出現延遲、中斷或錯誤，我們不承擔任何責任和損失;雙方任何一方因政府禁令、工等、現行生效的法律法規變更，軟件調整無法繼續正常使用，洪水、爆炸、雷電、地震、電信通訊線路中斷等以及其他不可抗力事件的影響，從而全部或者部分不能履行本協議的，我們不承擔任何責任和損失。\n' +
      '考核無隔夜限制，僅限交易各品種的現貨交易和合約交易。',

  // 產品-個人挑戰
  'pages.personal.banner.title':'個人挑戰',
  'pages.personal.banner.text':'鑒於資金規模因素，為篩選出具備持續穩定盈利能力的優秀交易員，特開設傳奇賽和短線賽兩種賽制。\n'+
      '設置這兩種賽制，旨在避免交易員僅憑藉運氣通過單日交易或單筆操作就達成高收益目標，卻缺乏真正穩定的交易能力。故設立此賽制，歡迎廣大交易員踴躍報名參加。',

  // 合夥人計劃
  'pages.partnership.title1':'合夥人',
  'pages.partnership.title2':'計劃',
  'pages.partnership.title3':'獎勵',
  'pages.partnership.title4':'說明',
  'pages.partnership.title5':'推廣',
  'pages.partnership.title6':'及',
  'pages.partnership.subTitle':'成為聯盟合作夥伴，通過推廣Findtrader的付費產品來賺錢',
  'pages.partnership.email':'通過Findtrader賺錢\n' +
      '加盟詳情請聯絡官方人員(郵箱:Findtrader@outlook.com;\n' +
      'telegram:(@bike9927)\n',
  'pages.partnership.explanation.text1':'1.每新增一名用戶邀請人賬戶獲得',
  'pages.partnership.explanation.text2':'100積分',
  'pages.partnership.explanation.text3':'2.受邀用戶通過比賽獲得實盤賬戶後，該用戶',
  'pages.partnership.explanation.text4':'受益的10%',
  'pages.partnership.explanation.text5':'以上將給予合夥人',
  'pages.partnership.explanation.text6':'(實盤賬戶被收回，獎勵終止)',
  'pages.partnership.explanation.text7':'3.激活合夥人模式後，金幣可',
  'pages.partnership.explanation.text8':'等比提現',
  'pages.partnership.explanation.text9':'合夥人所有獎勵均有公司承擔。',
  'pages.partnership.explanation.text10':'4.合夥人模式為每月重新計算。',
  'pages.partnership.explanation.text11':'嚴格禁止包含關鍵字的付費廣告活動，例如以任何格式和語言編寫的品牌名稱(例如FindTrader、fndtrader.net、Findtrader、 fnd trader)',

  // 個人資料
  'pages.profile.tabs.personal':'個人信息',
  'pages.profile.tabs.account':'賬戶信息',
  'pages.profile.account.doing':'進行中',
  'pages.profile.account.undo':'未開始',
  'pages.profile.account.apply':'申請',
  'pages.profile.account.elite-competition':'精英賽',
  'pages.profile.account.elite-competition.short':'短線賽賬戶',
  'pages.profile.account.elite-competition.good':'優選賽賬戶',

  'pages.profile.account.base-account':'基礎賬戶',
  'pages.profile.account.pro-account':'進階賬戶',

  'pages.profile.tabs.verification':'認證信息',
  'pages.profile.account.monnthAccount':'月賽賬戶',
  'pages.profile.account.short':'短賽線賬戶',
  'pages.profile.account.preferred':'優選賽賬戶',
  'pages.profile.account.tooltip':'精英賽每月僅能二選一參與',

  // 登錄頁
  'pages.layouts.userLayout.title': 'Ant Design 是西湖區最具影響力的 Web 設計規範',
  'pages.login.accountLogin.tab': '賬戶密碼登錄',
  'pages.login.accountLogin.errorMessage': '錯誤的用戶名和密碼',
  'pages.login.failure': '登錄失敗，請重試！',
  'pages.login.success': '登錄成功！',
  'pages.login.username.placeholder': '請輸入用戶名',
  'pages.login.username.required': '用戶名是必填項！',
  'pages.login.password.placeholder': '請輸入密碼',
  'pages.login.password.required': '密碼是必填項！',
  'pages.login.phoneLogin.tab': '手機號登錄',
  'pages.login.phoneLogin.errorMessage': '驗證碼錯誤',
  'pages.login.phoneNumber.placeholder': '請輸入手機號！',
  'pages.login.phoneNumber.required': '手機號是必填項！',
  'pages.login.phoneNumber.invalid': '不合法的手機號！',
  'pages.login.captcha.placeholder': '請輸入驗證碼！',
  'pages.login.captcha.required': '驗證碼是必填項！',
  'pages.login.phoneLogin.getVerificationCode': '發送驗證碼',
  'pages.getCaptchaSecondText': '秒後重新發送',
  'pages.login.rememberMe': '記住我',
  'pages.login.forgotPassword': '忘記密碼 ?',
  'pages.login.submit': '登錄',
  'pages.login.loginWith': '其他登錄方式 :',
  'pages.login.registerAccount': '註冊賬戶',

  //FAQ
  'pages.faq.type.title':'頂級交易員常見問題解答',
  'pages.faq.type.sub-title':'選擇問題類型以便於查找',
  'pages.faq.type.placeholder':'搜索相關文章',
  'pages.faq.type.link-text':'篇文章',
  'pages.faq.list.title':'交易信息',

  //儀表盤
  'pages.pannel.welcome': '歡迎回來',
  'pages.pannel.accountInfo': '当前权益',
  "pages.pannel.actual-rate-return":'实际收益率',
  'pages.pannel.assess': '評估',
  'pages.pannel.total-profit': '總利潤',
  'pages.pannel.total-volume': '總交易量',
  'pages.pannel.account-overview': '提交總量',
  'pages.pannel.profit-target': '盈利目標',
  'pages.pannel.maximum-loss': '本金最大亏损',
  'pages.pannel.aximum-drawdown': '最大回撤(高水位)',
  'pages.pannel.current-equity': '當前權益',
  'pages.pannel.target-equity': '目標權益',
  'pages.pannel.transaction-record': '交易記錄',

  'pages.welcome.link': '歡迎使用',
  'pages.welcome.alertMessage': '更快更強的重型組件，已經發布。',
  'pages.404.subTitle': '抱歉，您訪問的頁面不存在。',
  'pages.404.buttonText': '返回首頁',
  'pages.admin.subPage.title': ' 這個頁面只有 admin 權限才能查看',
  'pages.admin.subPage.alertMessage': 'umi ui 現已發布，歡迎使用 npm run ui 啟動體驗。',
  'pages.searchTable.createForm.newRule': '新建規則',
  'pages.searchTable.updateForm.ruleConfig': '規則配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '規則名稱',
  'pages.searchTable.updateForm.ruleName.nameRules': '請輸入規則名稱！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '規則描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '請輸入至少五個字符',
  'pages.searchTable.updateForm.ruleDesc.descRules': '請輸入至少五個字符的規則描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置規則屬性',
  'pages.searchTable.updateForm.object': '監控對象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '規則模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '規則類型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '設定調度週期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '請選擇開始時間！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '規則名稱為必填項',
  'pages.searchTable.titleCallNo': '服務調用次數',
  'pages.searchTable.titleStatus': '狀態',
  'pages.searchTable.nameStatus.default': '關閉',
  'pages.searchTable.nameStatus.running': '運行中',
  'pages.searchTable.nameStatus.online': '已上線',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '上次調度時間',
  'pages.searchTable.exception': '請輸入異常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '訂閱警報',
  'pages.searchTable.title': '查詢表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已選擇',
  'pages.searchTable.item': '項',
  'pages.searchTable.totalServiceCalls': '服務調用次數總計',
  'pages.searchTable.tenThousand': '萬',
  'pages.searchTable.batchDeletion': '批量刪除',
  'pages.searchTable.batchApproval': '批量審批',
};